module.exports = __webpack_public_path__ + "static/img/6.de929c83.png";